import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'
import { colors } from '../colors'

export const SelectContainer = styled.div`
  position: relative;
  border: 1px solid ${colors.gray200};
  border-radius: 10px;
  width: 100%;
`

export const SelectButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  padding: 10px;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  color: ${colors.gray900};
  text-align: left;
  font-weight: bold;

  &:hover {
    background-color: ${colors.gray50};
  }

  &:focus {
    outline: none;
    background-color: ${colors.gray100};
  }

  &:disabled {
    background-color: ${colors.gray200};
  }
`

export const SelectDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: ${colors.white};
  border: 1px solid ${colors.gray300};
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  margin-top: 4px;
  min-height: 50px;
  display: flex;
  flex-direction: column;
  max-height: 280px;
  overflow: hidden;
`

export const SelectSearchWrapper = styled.label`
  display: flex;
  align-items: center;
  padding: 10px 12px;
  gap: 8px;
  border-bottom: 1px solid ${colors.gray100};
  background: ${colors.white};
`

export const SelectSearchIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.gray400};
`

export const SelectSearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-size: 14px;
  color: ${colors.gray900};
  background: transparent;

  &::placeholder {
    color: ${colors.gray400};
  }
`

export const SelectOptionsList = styled.div`
  overflow-y: auto;
  max-height: 220px;
`

export const SelectEmptyState = styled.div`
  padding: 12px 16px;
  color: ${colors.gray500};
  font-size: 14px;
`

export const SelectOption = styled.div<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  background-color: ${({ isSelected }) =>
    isSelected ? colors.gray50 : 'transparent'};

  &:hover {
    background-color: ${colors.gray100};
  }

  &:first-of-type {
    border-radius: 6px 6px 0 0;
  }

  &:last-child {
    border-radius: 0 0 6px 6px;
  }
`

export const SelectOptionText = styled.span`
  font-size: 14px;
  color: ${colors.gray900};
`

export const SelectOptionCheck = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
`

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const SelectLoader = styled.span`
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid ${colors.gray200};
  border-top-color: ${colors.orange500};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`

export const SelectLoadingState = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  color: ${colors.gray500};
  font-size: 14px;
`
